import { Country } from '@/models/country';

/** Points table copy shown in Rules and on the home page (scoring logic may differ until backend update). */
export const DISPLAY_POINTS_SYSTEM: readonly [label: string, points: number][] = [
  ['Goal', 1],
  ['Win', 3],
  ['Draw', 1],
  ['Round of 32', 3],
  ['Round of 16', 6],
  ['Quarter Final', 9],
  ['Semi Final', 12],
  ['Final', 15],
  ['Winner', 18],
];

/** Example ranked list for Rules → Score Points (WC 2026 teams; seeds at ranks 1–4). */
export const RULES_SCORE_EXAMPLE_LIST: readonly [country: Country, points: number, multiplier: string, weighted: number][] = [
  [Country.ES, 8, 'x10', 80],
  [Country.GB_ENG, 7, 'x9', 63],
  [Country.US, 16, 'x8', 128],
  [Country.FR, 11, 'x7', 77],
  [Country.NO, 9, 'x6', 54],
  [Country.EGY, 5, 'x5', 25],
  [Country.UZB, 10, 'x4', 40],
  [Country.GB_SCT, 13, 'x3', 39],
  [Country.GH, 6, 'x2', 12],
  [Country.CPV, 4, 'x1', 4],
];

export const RULES_SCORE_EXAMPLE_TOTAL = RULES_SCORE_EXAMPLE_LIST.reduce((sum, row) => sum + row[3], 0);
